import React from 'react';
import { Button, Table } from 'semantic-ui-react';
import styles from './FilesTable.module.scss';

type Props = {
  index: number;
  file: File;
  onDelete: (index: number, file: File) => void;
};

function DeleteCell({ index, file, onDelete }: Props) {
  return (
    <Table.Cell className={styles.deleteColumn}>
      <div>
        <Button
          icon="remove"
          color="red"
          className="mouseCursorPointer mini"
          onClick={() => {
            onDelete(index, file);
          }}
        />
      </div>
    </Table.Cell>
  );
}

export default DeleteCell;
